// src/core/mode.ts — the finite state machine (grounding §3), ported from LLABARO.jsx.
// Pure and rendering-free. The oracle test locks this behaviour down.
import type { Mode } from "./models";

export const MODE = {
  IDLE: "IDLE",
  LISTENING: "LISTENING",
  TALK_CAPTURE: "TALK_CAPTURE",
  TRANSLATING: "TRANSLATING",
  SPEAKING: "SPEAKING",
} as const;

export const LISTEN_SUSPENDED: ReadonlySet<Mode> = new Set<Mode>([
  "TALK_CAPTURE",
  "TRANSLATING",
  "SPEAKING",
]);

export const isListenSuspended = (s: Mode): boolean => LISTEN_SUSPENDED.has(s);
export const initialMode = (hasKey: boolean): Mode => (hasKey ? "LISTENING" : "IDLE");

export type ModeAction =
  | { type: "KEY_READY" }
  | { type: "PRESS" }
  | { type: "RELEASE" }
  | { type: "CANCEL" }
  | { type: "TRANSLATED"; ttsEnabled: boolean }
  | { type: "TRANSLATE_ERROR" }
  | { type: "SPOKEN" }
  | { type: "SESSION_DROP" };

export function modeReducer(state: Mode, action: ModeAction): Mode {
  switch (action.type) {
    case "KEY_READY":
      return state === "IDLE" ? "LISTENING" : state;
    case "PRESS":
      return state === "LISTENING" ? "TALK_CAPTURE" : state;
    case "RELEASE":
      return state === "TALK_CAPTURE" ? "TRANSLATING" : state;
    case "CANCEL":
      return state === "TALK_CAPTURE" ? "LISTENING" : state;
    case "TRANSLATED":
      if (state !== "TRANSLATING") return state;
      return action.ttsEnabled ? "SPEAKING" : "LISTENING";
    case "TRANSLATE_ERROR":
      return state === "TRANSLATING" ? "LISTENING" : state;
    case "SPOKEN":
      return state === "SPEAKING" ? "LISTENING" : state;
    case "SESSION_DROP":
      return "IDLE";
    default:
      return state;
  }
}
